import type { MantineColorsTuple } from '@mantine/core'

export const rezolvePrimaryColors: MantineColorsTuple = [
  '#F0F5FB', // 0 - rzv-blue-50 (--rzv-info-bg / --rzv-ai-bg-soft)
  '#DCE7F3', // 1 - rzv-blue-100
  '#B5CCE4', // 2 - rzv-blue-200
  '#8AAED3', // 3 - rzv-blue-300
  '#5A8AC3', // 4 - rzv-blue-400 ★ primaryShade
  '#4976AD', // 5 - rzv-blue-500
  '#3A6292', // 6 - rzv-blue-600
  '#2D4E76', // 7 - rzv-blue-700
  '#213A59', // 8 - rzv-blue-800
  '#16273D', // 9 - rzv-blue-900
]

export const rezolveGreenColors: MantineColorsTuple = [
  '#f0faf5', // 0
  '#E3F5EC', // 1 - rzv design bg tint
  '#c1ebd6', // 2
  '#8fdcb9', // 3
  '#53c898', // 4
  '#0E9F6E', // 5 - rzv design hero ★
  '#0a8960', // 6
  '#087352', // 7
  '#065c42', // 8
  '#044633', // 9
]

export const rezolveRedColors: MantineColorsTuple = [
  '#fef5f5', // 0
  '#FDECEC', // 1 - rzv design bg tint
  '#fad5d5', // 2
  '#f5adad', // 3
  '#ed7a7a', // 4
  '#DC2626', // 5 - rzv design hero ★
  '#c01c1c', // 6
  '#a21616', // 7
  '#851111', // 8
  '#680c0c', // 9
]

// Amber scale — built around the DS warning tokens (--rzv-warn / --rzv-warn-bg)
export const rezolveYellowColors: MantineColorsTuple = [
  '#FFFAF4', // 0
  '#FEF2E3', // 1 - rzv design bg tint (--rzv-warn-bg) ★
  '#FDE0BB', // 2
  '#FAC882', // 3
  '#F5A846', // 4
  '#D97706', // 5 - rzv design hero (--rzv-warn) ★
  '#B86305', // 6
  '#954E04', // 7
  '#723B03', // 8
  '#502902', // 9
]

// Derived from the rzv-ink scale (ink-50 through ink-900)
export const rezolveGrayColors: MantineColorsTuple = [
  '#FAFAFA', // 0 - rzv-ink-50
  '#F3F3F4', // 1 - rzv-ink-100
  '#E7E7EA', // 2 - rzv-ink-200
  '#D1D1D6', // 3 - rzv-ink-300
  '#A1A1AA', // 4 - rzv-ink-400
  '#71717A', // 5 - rzv-ink-500
  '#52525B', // 6 - rzv-ink-600
  '#3F3F46', // 7 - rzv-ink-700
  '#27272A', // 8 - rzv-ink-800
  '#18181B', // 9 - rzv-ink-900
]

/** @deprecated Use rezolvePrimaryColors */
export const bluedotPrimaryColors: MantineColorsTuple = [
  '#f7eaff',
  '#e7d1ff',
  '#cba0fc',
  '#ad6bf8',
  '#953ff5',
  '#8523f4',
  '#7d14f4',
  '#6b08da',
  '#5f04c3',
  '#5100ac',
]
